import styled, { css } from 'styled-components';
import { avatarTokens } from '../../tokens/components/Avatar/tokens';
import { StyledButton } from '../Button/Button';

const initialsVariant = {
  primary: css`
    background-color: ${avatarTokens.BackgroundInitialsPrimaryColor};
    color: ${avatarTokens.FontColorInitialsPrimaryColor};
  `,
  secondary: css`
    background-color: ${avatarTokens.BackgroundInitialsSecondaryColor};
    color: ${avatarTokens.FontColorInitialsSecondaryColor};
  `,
  tertiary: css`
    background-color: ${avatarTokens.BackgroundInitialsTertiaryColor};
    color: ${avatarTokens.FontColorInitialsTertiaryColor};
  `,
};

/* @internal */
export const AvatarIcon = styled.div`
  align-items: center;
  background-color: ${avatarTokens.BackgroundBaseColor};
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: ${avatarTokens.BorderRadius};
  color: ${avatarTokens.FontColorDefault};
  display: flex;
  font-weight: ${avatarTokens.FontWeight};
  height: ${avatarTokens.SizeDefault};
  justify-content: center;
  min-width: ${avatarTokens.SizeDefault};
  overflow: hidden;
  position: relative;
  width: ${avatarTokens.SizeDefault};

  svg {
    width: 100%;
  }

  ${({ theme }) =>
    theme.avatarSecondaryText &&
    css`
      margin-top: ${theme.avatarCompany ? '2px' : '5px'};
    `}

  ${({ theme }) =>
    theme.avatarCompany &&
    css`
      border-color: ${avatarTokens.BorderColorBaseDefault};
      border-radius: 0;
      border-style: ${avatarTokens.BorderStyleBaseDefault};
      border-width: ${avatarTokens.BorderWidthBaseDefault};
      box-sizing: content-box;
      color: transparent;
      font-size: 0;
      min-width: 80px;
      width: 80px;
    `}

  ${({ theme }) =>
    theme.avatarInitials &&
    css`
      background: ${avatarTokens.BackgroundInitialsDefaultColor};
      color: ${avatarTokens.FontColorInitialsDefaultColor};

      ${theme.avatarInitialsVariant &&
      css`
        ${initialsVariant[theme.avatarInitialsVariant]};
      `};
    `};
`;

export const AvatarInfo = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 8px;

  &:only-child {
    padding-left: 0;
  }
`;

/* @internal */
export const StyledAvatar = styled.div`
  align-self: flex-start;
  display: inline-flex;
  position: relative;
  vertical-align: middle;

  & ~ & {
    margin-left: 1rem;
  }

  ${StyledButton} & {
    margin-top: calc(10px / 2);
    margin-bottom: calc(10px / 2);
  }

  ${({ theme }) =>
    theme.avatarCell &&
    css`
      display: inline-flex;
      margin-bottom: 4px;
      vertical-align: top;
      white-space: nowrap;
      width: 100%;

      ${AvatarIcon} {
        vertical-align: top;

        ~ ${AvatarInfo} {
          max-width: calc(100% - 38px);
        }

        ${theme.avatarCompany &&
        css`
          ~ ${AvatarInfo} {
            max-width: calc(100% - 80px);
          }
        `}

        ${theme.avatarInitials &&
        css`
          text-align: center;
        `}
      }

      ${AvatarInfo} {
        max-width: 100%;
        white-space: normal;
      }

      // When Avatar is used inside the old Table, this styling
      // will change the color to white when the row is selected.
      // When we kill Table, this can be removed
      .ink-table--body--row__selected & {
        .ink-text__300,
        .ink-text__400 {
          color: ${avatarTokens.FontColorWhite};
        }
      }
    `}
`;
